export default "__VITE_ASSET__4949806d__"